module.exports = __webpack_public_path__ + "static/media/slide2.7ae02131.png";